
import { Component } from '@theme/component';
import { clamp } from '@theme/utilities';

class ReadingProgress extends Component {
  #bar = null;
  #articolo = null;
  #raf = 0;

  #update = () => {
    this.#raf = 0;
    const fine = this.#articolo.getBoundingClientRect().bottom + window.scrollY;
    const percorso = Math.max(fine - window.innerHeight, 1);
    this.#bar.style.setProperty('--progress', `${clamp(window.scrollY / percorso, 0, 1) * 100}%`);
  };

  #request = () => {
    if (!this.#raf) this.#raf = requestAnimationFrame(this.#update);
  };

  connectedCallback() {
    super.connectedCallback();
    this.#bar = this.querySelector('[data-progress]');
    if (!this.#bar) return;

    // Di default misura la sezione in cui sta (l articolo intero). Dove il componente vive in una
    // sezione corta, come l intro della Guida, data-progress-scope dice cosa misurare davvero.
    const scope = this.dataset.progressScope && document.querySelector(this.dataset.progressScope);
    this.#articolo = scope || this.closest('.shopify-section') || document.documentElement;

    window.addEventListener('scroll', this.#request, { passive: true });
    window.addEventListener('resize', this.#request);
    this.#update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('scroll', this.#request);
    window.removeEventListener('resize', this.#request);
    cancelAnimationFrame(this.#raf);
  }
}

if (!customElements.get('reading-progress-component')) customElements.define('reading-progress-component', ReadingProgress);
